import React from 'react'; 
import './footer.css';
import { FaInstagram, FaGithub, FaLinkedin } from "react-icons/fa";
import { PiSpotifyLogoFill } from "react-icons/pi";

const socialLinks = [
    {
        id: 1, 
        icon: <FaInstagram className="white-icon"/>,
        url: "https://www.instagram.com/frank_zhang_v2/",
    },
    {
        id: 2,
        icon: <FaGithub className="white-icon"/>,
        url: "https://github.com/gilberty005",
    },
    {
        id: 3,
        icon: <FaLinkedin className="white-icon"/>,
        url: "https://www.linkedin.com/in/mikhail-kolobanov-71699a296/",
    },
    {
        id: 4,
        icon: <PiSpotifyLogoFill className="white-icon"/>,
        url: "https://open.spotify.com/user/42nau3st5f3bpq9uso520im53?si=07d655bb5ddd462a",
    }
];

const Footer = () => (
    <div className="gilbert__footer section__padding">
      <div className="gilbert__footer-links">
      <div className="gilbert__footer-links_social"> {/* Move social icons div above */}
        {socialLinks.map((link) => (
          <a key={link.id} href={link.url} target="_blank" rel="noopener noreferrer">
            {link.icon}
          </a>
        ))}
      </div>
      <div className="gilbert__footer-links_logo">
        <p>© 2025 by [redacted] with &lt;3</p>
      </div>
      </div>
    </div>
);

export default Footer; 